module.exports = __webpack_public_path__ + "static/media/checkIn.12cb412c.svg";